import { Assets } from 'pixi.js'
import bgUrl from '../assets/bg.png?url'
import bgPatternUrl from '../assets/bg_pattern.png?url'
import cloudUrl from '../assets/cloud.png?url'
import jetSpineUrl from '../assets/jet/JetAnime.json?url'
import jetSpineAtlasUrl from '../assets/jet/JetAnime.atlas?url'
import jetSpineImageUrl from '../assets/jet/JetAnime.png?url'
import blastSpineUrl from '../assets/blast/Blast.json?url'
import blastSpineAtlasUrl from '../assets/blast/Blast.atlas?url'
import blastSpineImageUrl from '../assets/blast/Blast.png?url'
import montserratBoldUrl from '../assets/fonts/Montserrat-Bold.otf?url'

export class AssetManager {
	private static loaded = false

	static get isLoaded() {
		return this.loaded
	}

	static async loadAll(onProgress?: (progress: number) => void) {
		if (this.loaded) {
			onProgress?.(1)
			return
		}

		const font = new FontFace('Montserrat-Bold', `url(${montserratBoldUrl})`)
		await font.load()
		document.fonts.add(font)

		// Atlas page PNGs must be imported explicitly — Vite only emits them when
		// referenced in JS. In production the hashed atlas URL cannot resolve sibling PNGs.
		await Assets.load(
			[
				{ alias: 'bg', src: bgUrl },
				{ alias: 'bg_pattern', src: bgPatternUrl },
				{ alias: 'cloud', src: cloudUrl },
				{ alias: 'jetSpine', src: jetSpineUrl },
				{
					alias: 'jetSpineAtlas',
					src: jetSpineAtlasUrl,
					data: {
						images: {
							'JetAnime.png': jetSpineImageUrl,
						},
					},
				},
				{ alias: 'blastSpine', src: blastSpineUrl },
				{
					alias: 'blastSpineAtlas',
					src: blastSpineAtlasUrl,
					data: {
						images: {
							'Blast.png': blastSpineImageUrl,
						},
					},
				},
			],
			(progress) => {
				onProgress?.(progress)
			},
		)

		this.loaded = true
	}
}
